import { styled } from '@frontend/theme';
import { Box as MUIBox } from '@mui/material';

export const NotificationsDrawerWrapper = styled(MUIBox)(() => ({
  display: 'flex',
  flexDirection: 'column',
}));

export const NotificationsBannersWrapper = styled(MUIBox)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  padding: '16px 20px',
  gap: '16px',

  [theme.breakpoints.down('desktop')]: {
    padding: '16px 24px',
  },
}));
